/** Cupom Stripe / marketing — primeira consulta no agendamento público. */
export const SCHEDULING_FIRST_SESSION_PROMO_CODE = 'PRIMEIRASESSAO';

export const SCHEDULING_FIRST_SESSION_PROMO_PRICE_BRL = 60;
